var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.83333L14.1667 4.33333C14.4753 4.64197 14.4753 5.14197 14.1667 5.45061L6.45069 13.1666C6.31123 13.3061 6.13893 13.3961 5.95189 13.4257L3.16669 13.9166C2.86981 13.9704 2.57014 13.8704 2.35883 13.6591C2.14752 13.4478 2.04752 13.1481 2.10133 12.8512L2.59219 10.066C2.62185 9.87893 2.71185 9.70664 2.85131 9.56717L10.5673 1.85117C10.8759 1.54254 11.3759 1.54254 11.6846 1.85117L11.6667 1.83333ZM11.6667 1.83333L12.8667 3.03333",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a21b175a61807feb3e3089c770f7ca06.svg";
export { ForwardRef as ReactComponent };